import { render, staticRenderFns } from "./ProductDetailPopup.vue?vue&type=template&id=5ab16c79&scoped=true&"
import script from "./ProductDetailPopup.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailPopup.vue?vue&type=style&index=0&id=5ab16c79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab16c79",
  null
  
)

export default component.exports